export const capitalize = (str, lowerCaseRest = false) => {
    if (!str?.length) return str;
    const lowerStr = lowerCaseRest ? str.toLowerCase() : str;
    return lowerStr
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("");
    // return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
};

export const addCommaToBigInt = (value) => {
    if (!value) return "";

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
